// extracted by mini-css-extract-plugin
module.exports = {"openImageButton":"OpenImageButton_openImageButton__1DmWq"};